/**
 * Azure AD configuration for MSAL authentication
 */
import { Configuration, PopupRequest } from "@azure/msal-browser";

// Azure AD configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: (window as any).AZURE_CLIENT_ID || "", // Will be set by backend template
    authority: "https://login.microsoftonline.com/common", // Use 'common' for multi-tenant
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email"],
  prompt: "select_account"
};

// Add scopes for the access token
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

// Azure AD domain validation
export const ALLOWED_DOMAIN = "arquitecturayconcreto.com";

// Note: Role validation is now handled by the backend
// We only validate domain on the frontend for quick feedback